import ExternalLayout from '../../layout/External'
import LogoNevula from '../../assets/images/logo-nevula.svg'
import Button from '../../components/General/Button'
import { FiCreditCard } from 'react-icons/fi'
import { RiUserSharedFill } from 'react-icons/ri'
import { BiTransfer } from 'react-icons/bi'
import { useState } from 'react'
import Modal from '../../components/Display/Modal'
import PaymentForm from './PaymentForm'
import { useHistory } from 'react-router'

const RegisterSeventh: React.FC<any> = () => {
  const methods = [
    {
      name: 'Tarjeta',
      icon: FiCreditCard,
    },
    {
      name: 'Transferencia',
      icon: RiUserSharedFill,
    },
    {
      name: 'Otro',
      icon: BiTransfer,
    },
  ]

  const [typeSelected, setTypeSelected] = useState<string | null>(null)

  const history = useHistory()

  const onShowModal = (type: string): void => {
    setTypeSelected(type)
  }

  return (
    <div id="main" style={{height: '100vh'}}>
      <div className="flex flex-col items-center bg-white dark:bg-gray-800 mb-6" style={{height: "100vh"}}>
        <div className="w-full flex flex-nowrap justify-between py-10 px-14">
          <div className="w-52">
            <img src={LogoNevula} alt="nevula" />
          </div>
          <Button type="outline" classes="h-12 rounded-3xl" onClick={() => history.push("/ingresar")}>
            Iniciar mes de prueba gratis
          </Button>
        </div>
        <h1>Configura tu pago</h1>
        <label style={{ color: '#979797', marginTop: 20 }}>
          Precios accesibles que nos ayudaran a junto a tu negocio{' '}
        </label>

        <div className="mt-10">
          {methods.map((method) => (
            <div
              className="shadow-md bg-white dark:bg-black rounded px-5 h-16 w-96 mb-5 flex items-center cursor-pointer"
              onClick={() => onShowModal(method.name)}
            >
              <div
                style={{
                  height: 38,
                  width: 40,
                  backgroundColor: '#71A7E84D',
                  borderRadius: 20,
                }}
                className="flex justify-center	items-center"
              >
                {<method.icon style={{ color: '#006AEA' }} />}
              </div>

              <div className="ml-3">
                <label style={{ fontWeight: 500 }}>{method.name}</label>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal
        xlClasses="xl:w-1/3"
        display={!!typeSelected}
        onClose={() => setTypeSelected(null)}
      >
        <PaymentForm type={typeSelected} onSubmitProp={() => console.log('submit...')} onCloseProp={() => setTypeSelected(null)} />
      </Modal>
    </div>
  )
}

export default RegisterSeventh
